import React from 'react';
import { ReactSVG } from 'react-svg';
import Svg from 'assets/images/ai-assistant/chat-modal-retry/ai-star.svg';
import './AIStarIcon.scss';

type Props = {
  className?: string;
  width?: number;
  height?: number;
};

export const AIStarIcon = ({ className, width = 150, height = 150 }: Props) => {
  return (
    <ReactSVG
      className={`ai-star ${className}`}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        display: 'inline-block',
      }}
      src={Svg}
    />
  );
};
